export default {
  Standard: "Standard",
  Admin: "Admin",
  IP: "IP"
};
